export default {
  evaluation_dashboard: {
    title: 'Dashboard für Käufer',
    unit: 'Unternehmen',
    average: 'Durchschnittliche Bewertung:',
    point: 'Punkte',
    answered_label: 'Eingereicht',
    evaluated_label: 'Bewertet',
    // corporate_average: "",
    points_earned_by_companies: "Ihre Lieferanten\' Punkteverteilung",
    year_modal: {
      title: 'Jahr auswählen',
      label: 'Jahr',
    },
    response_status_title: 'Verteilung des Antwortstatus',
    response_status_rating_nothing: 'Noch keine Antworten',
    esg_rating_title: 'ESG-Rating-Verteilung',
    esg_score_title: 'ESG Score-Verteilung',
    category_scores_title: 'Vergleich der Punktzahlen nach Kategorie',
    category_scores_distribution_title: 'Punkteverteilung nach Kategorie',
    category_score_data_all_label: 'Alle von Asene ESG bewerteten Unternehmen',
    esg_scores_by_industry_title: 'ESG-Score-Verteilung nach Branche',
    environment_score_title: 'Verteilung der Umwelt-Scores',
    social_score_title: 'Verteilung der Sozialpunkte',
    governance_score_title: 'Verteilung der Governance-Punkte',
    environment_score_subtitle_upper5: 'Top 5 Umwelt Scores',
    environment_score_subtitle_lower5: 'Schlechteste 5 Umwelt-Bewertungen',
    social_score_subtitle_upper5: 'Top 5 Soziales Scores',
    social_score_subtitle_lower5: 'Schlechteste 5 Sozialbewertungen',
    governance_score_subtitle_upper5: 'Top 5 Punkte für Governance',
    governance_score_subtitle_lower5: 'Schlechteste 5 Governance-Bewertungen',
    // empty_error_message: "",
    common: {
      companies: 'Unternehmen',
      update_date: 'Letztes Aktualisierungsdatum',
    },
    registration_rate: {
      title: 'Registrierungsquote',
      tip: 'In ASUENE ESG registrierte Unternehmen im Verhältnis zur Gesamtzahl der zu bewertenden Unternehmen',
    },
    answer_rate: {
      title: 'Einreichungsquote',
      tip: 'Unternehmen, die die Umfrage eingereicht haben, bezogen auf die Gesamtzahl der zu bewertenden Unternehmen',
    },
    days_remaining: {
      title: 'Tage bis zum Ende der Umfrage',
      tip: 'Verbleibende Tage bis zur gesetzten Frist.\nWenn Sie die Frist ändern möchten, kontaktieren Sie uns bitte.',
      days_remaining_before: '',
      days_remaining_after: 'verbleibende Tage',
      expired: 'Die Frist wurde überschritten.',
    },
    answer_transition: {
      title: 'Trend zur Einreichung',
      companies_submitted: 'Eingereichte Unternehmen',
      breakdown: 'Aufschlüsselung',
      unregistered: 'Unregistriert',
      total: 'Insgesamt',
      number_of_companies: 'Anzahl der Unternehmen',
    },
    answer_list: {
      title: 'Letzte Einreichung',
      submitted_at: 'Datum der Antwort',
    },
  },
}
